<template>
  <div class="operations-email-dialog">
    <custom-dialog
      width="500px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
      :append-to-body="true"
    >
      <div class="dialog-body">
        <el-form ref="form" :model="form" :rules="rules" label-position="top" size="small">
          <el-form-item :label="$t('base_operations_email_dialog.you_xiang')" prop="email">
            <el-input v-model.trim="form.email" :placeholder="$t('base_operations_email_dialog.srdgyxqygkzdsr5gyx')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" :loading="submitting" @click="confirm">{{ $t('base_operations_email_dialog.que_ren') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      submitting: false,
      form: {
        genRecordId: '',
        email: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        email: [
          { required: true, message: this.$t('base_operations_email_dialog.qsryx'), trigger: 'blur' },
          { validator: this.validateEmail, trigger: 'blur' },
        ],
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const data = (this.model && this.model.data) || {};
      this.form.genRecordId = data.genRecordId || '';
      this.form.email = data.email || '';
    },
    closeDialog() {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    validateEmail(rule, value, callback) {
      const emailList = (value || '')
        .split(';')
        .map(item => item.trim())
        .filter(item => item);
      const emailReg = /^\w+([-.+]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!emailList.length) {
        callback(new Error(this.$t('base_operations_email_dialog.qsryx')));
        return;
      }
      if (emailList.length > 5) {
        callback(new Error(this.$t('base_operations_email_dialog.zdsr5gyx')));
        return;
      }
      const invalidEmail = emailList.find(item => !emailReg.test(item));
      if (invalidEmail) {
        callback(new Error(this.$t('base_operations_email_dialog.qsryxdyxdz')));
        return;
      }
      callback();
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const emailList = this.form.email
          .split(';')
          .map(item => item.trim())
          .filter(item => item);
        this.submitting = true;
        this.$postJSON(apis.workReportPushEmail, {
          genRecordId: this.form.genRecordId,
          email: this.form.email,
          emailList,
        }, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
  },
};
</script>

<style lang="scss">

</style>
